import { ComposedTheme, createUseStyles } from '@glu/theming';
import '../themeDefaults';

const styles = ({ formComponents }: ComposedTheme) => ({
  helpWrapper: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
  },
  inline: {},
  root: {
    '&$inline': {
      display: 'flex',
      justifyContent: 'center',
    },
    display: 'block',
    marginBottom: formComponents.container.marginBottom,
  },
  wrap: {
    width: '100%',
    flex: 1,
    position: 'relative',
  },
  tooltipErrorIcon: {
    position: 'absolute',
    top: 8,
    right: 8,
    '& svg': {
      fill: formComponents.error.color,
    },
    '&$tooltipErrorIconDark': {
      '& svg': {
        fill: formComponents.dark.error.color,
      },
    },
  },
  tooltipErrorIconDark: {},
});

export default createUseStyles(styles);
